import type { TFunction } from 'i18next';
import { z } from 'zod';

import {
	hcoEntitySchema,
	hcpEntitySchema
} from '@/core/dcr/schemas/entity.schema';
import { buildEntityDefaults } from '@/core/dcr/serialize/defaults';
import { EntityType } from '@/core/graphql/generated/types';

import { AttachmentSchema } from '../Attachments/attachment.schema';
import { ATTACHMENT_MAX_FILES } from '../Attachments/attachment.types';

const envelopeShape = () => ({
	notes: z.string().trim().nullish(),
	attachments: z
		.array(AttachmentSchema())
		.max(ATTACHMENT_MAX_FILES)
		.default([]),
	isThirdPartyDataConfirmed: z.boolean().nullish()
});

export const buildDcrFormSchema = (
	entityType: EntityType,
	ctx: {
		t: TFunction;
		countryId?: string | null;
		unavailable?: ReadonlySet<string>;
	}
) =>
	entityType === EntityType.Hcp
		? hcpEntitySchema(ctx, envelopeShape())
		: hcoEntitySchema(ctx, envelopeShape());

export const buildDcrFormDefaults = (
	entityType: EntityType
): Record<string, unknown> => ({
	...buildEntityDefaults(entityType),
	notes: '',
	attachments: [],
	isThirdPartyDataConfirmed: false
});
